<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 400 198"
    :width="props.width"
    :height="props.height"
    :style="{ fill: props.fill }"
  >
    <polygon
      :class="{ st0: !props.fill }"
      points="189.72 141.55 223.24 84.7 257.75 141.55 296.85 141.55 245.78 67.14 291.47 .31 253.76 .31 224.83 49.79 194.71 .31 155.61 .31 202.28 67.75 152.81 141.55 189.72 141.55"
    />
    <polygon
      :class="{ st0: !props.fill }"
      points="399.99 112.83 331.56 112.83 331.56 84.1 392.81 84.1 392.81 55.38 331.56 55.38 331.56 29.04 396.4 29.04 396.4 .31 300.44 .31 300.44 141.55 399.99 141.55 399.99 112.83"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M40.79,141.55l22.73-29.92h51.33l-.57,29.92h35.11L148.08.32h-33.88L1.16,141.55s39.62,0,39.62,0ZM116.81,41.48l-1.32,43.83h-31.96l33.3-43.83h0Z"
    />
    <polygon
      :class="{ st0: !props.fill }"
      points="17.04 183.17 4.71 183.17 4.71 173.29 1.48 173.29 1.48 197.08 4.71 197.08 4.71 186.19 17.04 186.19 17.04 197.08 20.26 197.08 20.26 173.29 17.04 173.29 17.04 183.17"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M44.87,180.75c-4.78,0-8.23,3.59-8.23,8.37s3.16,8.37,8.2,8.37c3.06,0,5.38-1.08,7.06-3.26l-2.29-1.75c-1.17,1.44-2.52,2.39-4.37,2.39-2.79,0-5.38-1.85-5.38-4.64h12.77v-1.08c0-4.1-2.15-8.4-7.76-8.4h0ZM39.87,187.81c0-2.11,1.95-4.64,4.94-4.64s4.54,1.98,4.6,4.64c0,0-9.54,0-9.54,0Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M81.28,186.06c0-2.75-1.95-5.31-6.65-5.31-2.22,0-4.64.77-6.32,2.35l1.82,1.88c1.11-.84,2.22-1.82,4.54-1.82,2.59,0,3.8,1.72,3.8,3.36v.67h-2.22c-4.84,0-8.77,1.41-8.77,5.51,0,3.09,2.56,4.78,5.51,4.78,2.42,0,4.23-.77,5.58-2.82h.07c0,.81.03,1.61.1,2.42h2.68c-.1-.84-.14-1.78-.14-2.89v-8.13h0ZM78.44,190.43c0,2.15-1.17,4.64-4.54,4.64-2.08,0-3.42-.77-3.42-2.59,0-2.56,3.49-3.06,6.35-3.06h1.61v1.01h0Z"
    />
    <rect :class="{ st0: !props.fill }" x="97.89" y="171.68" width="3.02" height="25.4" />
    <path
      :class="{ st0: !props.fill }"
      d="M121.88,190.99v-7.22h4.33v-2.62h-4.33v-4.47h-3.03v4.47h-3.49v2.62h3.49v8.3c0,2.56.07,5.41,4.74,5.41.6,0,2.01-.14,2.72-.54v-2.75c-.6.37-1.44.47-2.15.47-2.28,0-2.28-1.88-2.28-3.66h0Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M150.42,180.75c-2.46,0-4.47,1.17-5.24,2.85h-.07v-11.93h-3.02v25.4h3.02v-8.2c0-3.7,1.91-5.31,4.44-5.31,1.91,0,3.63,1.11,3.63,4.1v9.4h3.02v-10.25c0-4.23-2.68-6.08-5.78-6.08v.02Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M197,179.34c0-1.48,1.08-3.63,4.64-3.63,1.85,0,3.42.84,4.23,2.08l2.63-2.39c-1.78-2.18-4.26-2.72-6.86-2.72-5.71,0-8.06,3.87-8.06,6.65,0,9.28,11.72,5.88,11.72,11.36,0,2.62-2.62,3.97-4.74,3.97-1.91,0-3.9-.81-5.04-2.56l-2.65,2.29c1.61,2.25,4.54,3.3,7.59,3.3,4.57,0,8.27-2.75,8.27-7.36,0-8.57-11.72-4.97-11.72-10.98h0Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M231.99,180.75c-4.77,0-8.23,3.59-8.23,8.37s3.16,8.37,8.2,8.37c3.06,0,5.38-1.08,7.06-3.26l-2.28-1.75c-1.17,1.44-2.52,2.39-4.37,2.39-2.79,0-5.38-1.85-5.38-4.64h12.77v-1.08c0-4.1-2.15-8.4-7.77-8.4h0ZM226.99,187.81c0-2.11,1.95-4.64,4.94-4.64s4.54,1.98,4.6,4.64h-9.54Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M258.45,183.6h-.07v-2.46h-3.02v15.93h3.02v-7.99c0-3.49,1.61-5.1,4.57-5.1.47,0,.98.1,1.48.24l.14-3.26c-.4-.14-.87-.21-1.34-.21-1.98,0-4,1.17-4.77,2.85h0Z"
    />
    <polygon
      :class="{ st0: !props.fill }"
      points="286.11 193.35 281.33 181.16 277.84 181.16 284.32 197.08 287.66 197.08 293.9 181.16 290.68 181.16 286.11 193.35"
    />
    <rect :class="{ st0: !props.fill }" x="308.77" y="181.16" width="3.02" height="15.93" />
    <path
      :class="{ st0: !props.fill }"
      d="M310.28,173.22c-1.21,0-2.22,1.01-2.22,2.22s1.01,2.22,2.22,2.22,2.22-1.01,2.22-2.22-1.01-2.22-2.22-2.22Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M335.98,183.6c1.68,0,2.85.6,3.97,1.78l2.29-2.08c-1.58-1.72-3.8-2.52-6.12-2.52-4.97,0-8.33,3.49-8.33,8.4s3.42,8.3,8.33,8.3c2.32,0,4.47-.71,6.05-2.46l-2.15-2.15c-1.01,1.17-2.18,1.78-3.86,1.78-3.13,0-5.14-2.42-5.14-5.41s1.68-5.64,4.97-5.64h0Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M364.02,180.75c-4.77,0-8.23,3.59-8.23,8.37s3.16,8.37,8.2,8.37c3.06,0,5.38-1.08,7.06-3.26l-2.28-1.75c-1.17,1.44-2.52,2.39-4.37,2.39-2.79,0-5.38-1.85-5.38-4.64h12.77v-1.08c0-4.1-2.15-8.4-7.77-8.4h0ZM359.01,187.81c0-2.11,1.95-4.64,4.94-4.64s4.54,1.98,4.6,4.64h-9.54Z"
    />
    <path
      :class="{ st0: !props.fill }"
      d="M394,187.84c-1.34-.31-4.07-.57-4.07-2.49,0-1.14,1.24-1.78,2.65-1.78,1.51,0,2.56.71,3.26,1.58l2.35-1.78c-1.14-1.88-3.33-2.63-5.45-2.63-2.99,0-6.05,1.58-6.05,4.9,0,3.06,2.28,3.9,4.88,4.54,1.31.31,3.83.64,3.83,2.46,0,1.38-1.68,2.01-3.23,2.01-1.75,0-2.89-.91-3.86-1.88l-2.29,1.88c1.58,2.15,3.52,2.82,6.15,2.82,3.16,0,6.45-1.41,6.45-5,0-2.99-2.01-4-4.64-4.64h0Z"
    />
    <rect :class="{ st0: !props.fill }" y="156.99" width="400" height="2.63" />
  </svg>
</template>

<script setup lang="ts">
interface SVGProps {
  height: string
  width: string
  fill?: string
}

const props = defineProps<SVGProps>()
</script>

<style scoped>
.st0 {
  fill: #2769a6;
}
</style>
